"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikDialogWidget = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const useConfirmOnCloseRequest_1 = require("../hooks/useConfirmOnCloseRequest");
function FormikDialogWidget(_a) {
    var { initialValues, onSubmit, onReset, validateOnChange, validate, confirmAbandon, noAbandonDialog } = _a, props = tslib_1.__rest(_a, ["initialValues", "onSubmit", "onReset", "validateOnChange", "validate", "confirmAbandon", "noAbandonDialog"]);
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: onSubmit, onReset: onReset, validate: validate, validateOnChange: validateOnChange },
        react_1.default.createElement(formik_1.Form, { translate: '' }, noAbandonDialog
            ? react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, props))
            : react_1.default.createElement(FormikConnnectedDialog, Object.assign({}, props, { confirmAbandon: confirmAbandon })))));
}
exports.FormikDialogWidget = FormikDialogWidget;
function FormikConnnectedDialog(_a) {
    var { children, FooterContent, confirmAbandon, onCloseRequest } = _a, props = tslib_1.__rest(_a, ["children", "FooterContent", "confirmAbandon", "onCloseRequest"]);
    const { Dialog, abandon } = (0, useConfirmOnCloseRequest_1.useConfirmOnCloseRequest)(onCloseRequest, confirmAbandon);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dialog, null),
        react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, props, { onCloseRequest: abandon, footerContent: react_1.default.createElement(FooterContent, null) }), children)));
}
//# sourceMappingURL=FormikDialogWidget.js.map